import { Row } from '@components/Layout/Row';
import { SummarySelection } from '@components/SummarySelection';
import Paper from '@material-ui/core/Paper/Paper';
import React, { useContext } from 'react';
import { InstantQuoteContext } from './InstantQuoteStepper';
import IQHeadline from './IQHeadline';

export default function Summary(_props: any) {
    const { instantQuote, dispatch } = useContext<any>(InstantQuoteContext);

    const state = {
        package_id: instantQuote.package_id,
        package: instantQuote.package,
        skus_ids: instantQuote.skus_ids || [],
        package_skus: instantQuote.package_skus || [],
        skus: instantQuote.skus || [],
    };

    const category = (instantQuote.category || {}).name || '';

    const handleChange = (state) => dispatch({ type: 'updateSummary', payload: state });

    return (
        <>
            <IQHeadline
                headTitle={'Instant Free Quote'}
                title={'2. Selections'}
                text={`Select at least one extra or see all ${
                    /apparel/i.test(category) ? '' : `${category} `
                }Apparel to order single item.`}
            />

            <Row
                component={Paper}
                layout={'column'}
                style={{ marginTop: 0, minHeight: 70, position: 'relative' }}
                elevation={0}
                padding={0}
            >
                {instantQuote.category ? (
                    <SummarySelection
                        category={instantQuote.category}
                        value={state}
                        onChange={handleChange}
                        showPrices={true}
                    />
                ) : null}
            </Row>
        </>
    );
}
